import { Select,Form} from 'antd'
import React, { useEffect, useState } from 'react'
import { useGoodsTypeListQuery } from '../../store/ReactWebSiteApi';

function GetGoodsType(props) {
    const [list,setList] = useState();
    const {data, isSuccess} = useGoodsTypeListQuery({
        egt_e_id:localStorage.getItem('e_id'),
        egt_state:'2'
    });
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                //console.log(data);
                const newArr = data.Result.map((item) => {
                    const {egt_id,egt_name,}=item;
                    return item = {value:egt_id,label:egt_name}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <Form.Item
            wrapperCol={props.wrapperCol} 
            label={props.label} 
            required={props.required} 
            name={props.name}
        >
            <Select 
                options={list} 
                onChange={(_,f) => {
                    // console.log(f);
                    props.getGoodsType(f.value,f.label)
                }}
                placeholder={props.defaultId}
                style={props.style}
                value={props.value}
            /> 
        </Form.Item>
    )
}

export default GetGoodsType